<p>transaction-details works!</p>
